import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment, countryCd} from './util.service';
import {factoryRecommendedServices, IOpcodeRequest, IOpcodeResponse, IResponse, IZipCodeRequest,EngineDetail} from '@signal/asp-data-commons';
import {map, switchMap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {selectDealerCode} from '../../store/dealer/dealer.selectors';
import {Store} from '@ngrx/store';
import {DealerState} from '../../store/dealer/dealer.reducer';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {
  private aspCatalogApi: string;

  constructor(private readonly http: HttpClient,
              private readonly dealerState: Store<DealerState>) {
    this.aspCatalogApi = environment.aspCatalogApi;
  }

  getServiceOpcodes(opcodeRequest: IOpcodeRequest, countryCd:string, languageCd: string): Observable<IResponse<IOpcodeResponse>>{
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.post(`${(this.aspCatalogApi)}service-opcode/${dealerCode}/online/consumer?countryCode=${countryCd}&languageCode=${languageCd}`, opcodeRequest).pipe(
        map((data: IResponse<IOpcodeResponse>) => {
            return data;
          }
        ));
    }));
  }

  getAvailableMileages() {
    const countryAbbr= countryCd.toUpperCase() === 'USA' ? 'US' : 'MX';
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${(this.aspCatalogApi)}service-opcode/${dealerCode}/mileages?countryCode=${countryAbbr}`).pipe(
        map((data: IResponse<number[]>) => {
            return data;
        }));
    }));
  }
  getStateCitiesForZipcode(ZipCode){
    const countryAbbr= countryCd.toUpperCase() === 'USA' ? 'US' : 'MX';
    const zipcodearray=ZipCode.split(',');
    const zipCodeRequest:IZipCodeRequest[]=[];
    const requestbody= {"zipCodeRequest":[]}
    if(zipcodearray && zipcodearray.length){
      for(const zipcode of zipcodearray){
       this.setZipCodeRequest(zipcode,countryAbbr,zipCodeRequest)
      }
      requestbody.zipCodeRequest=zipCodeRequest;
    }
    return this.dealerState.select(selectDealerCode).pipe(
      switchMap(dealerCode => this.http.post(`${(this.aspCatalogApi)}catalog/${dealerCode}/lookup`,requestbody).pipe(
        map((data:IResponse<any>) => {
         return data;
        }
      ))));
  }
  private setZipCodeRequest(zipcode:string,CountryAbbr:string,zipCodeRequest:IZipCodeRequest[]){
    const zipcodeRequest:IZipCodeRequest={postalCode: zipcode,countryName: CountryAbbr}
    zipCodeRequest.push(zipcodeRequest);
  }
  getBase64ImageData(url){
    return this.dealerState.select(selectDealerCode).pipe(
      switchMap(dealerCode => this.http.get(`${(this.aspCatalogApi)}catalog/${dealerCode}/images?url=${url}`).pipe(
        map((data: IResponse<string>) => {
            return data;
          }
        )
      )));
  }
  getRecommendedService(opcodeRequest: IOpcodeRequest,engineDetail:EngineDetail,isLexus:boolean): Observable<IResponse<factoryRecommendedServices[]>>{
    const countryAbbr= countryCd.toUpperCase() === 'USA' ? 'US' : 'MX';
    return this.dealerState.select(selectDealerCode).pipe(
      //revert this dealerCode hardcode change later
      switchMap(dealerCode => this.http.post(`${(this.aspCatalogApi)}service-opcode/${dealerCode}/online/factoryrecommendedservice?engine=${engineDetail.engine}&transmission=${engineDetail.transmission}&driveType=${engineDetail.driveType}&isLexus=${isLexus}&countryCode=${countryAbbr}`, opcodeRequest).pipe(
        map((data: IResponse<factoryRecommendedServices[]>) => {
            return data;
          }
        )
      )));
  }
}
